/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name unavailabilityday
 */
angular.module('mercury.modules.time.roster')
.directive('unavailabilityday', ["reporttime", "$parse", function(reporttime, $parse) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element, attrs) {

      //attrs startTime and endTime are passed as strings from the angular template with quotes around them
      var unavailabilityStartTime = moment(attrs.startTime.replace(/"/g, ""));
      var unavailabilityEndTime = moment(attrs.endTime.replace(/"/g, ""));

      function recordLeftPosition(blockStartMoment) {
        // Get the number of minutes after the start of the grid day that the record starts
        // this is then used to determine how far left (i.e. away from the start of the
        // grid day) the block should be positioned.
        //
        // Note that this needs to handle records being on different chronological days
        // but the same company day. E.g. a company start time of 7am, and a shift
        // starting at 1am Tuesday. This block appears on the Monday 'day' on the roster.
        //
        // We rely on Moment's behaviour of setting the day() as an integer value also
        // updating the date to the _current week_. This means the grid we can compare
        // roster template days that have a completely different start _date_ to the view
        // start date, and still get the correct positioning - we only care about the day
        // portion of the clockin.
        const viewStartMoment = moment(scope.viewStartDateTime);

        const blockDay = blockStartMoment.day(); // e.g. Tuesday (1am start)
        const viewDay = viewStartMoment.day(); // e.g. Monday (7am start, 7am Tuesday end)

        const numberOfMinutesAfterDayStart = blockStartMoment.clone().day(blockDay)
          .diff(viewStartMoment.clone().day(viewDay), 'minutes');

        const percentDayStart = (numberOfMinutesAfterDayStart / 1440) * 100;
        return percentDayStart + '%';
      };

      // Function to return the percentage width of the unavailabilty record based on
      // how much of the 24hr day period it covers.
      function recordWidth(blockStartMoment, blockEndMoment) {
        var blockLengthMinutes = blockEndMoment.diff(blockStartMoment, 'minutes');
        var percentDayLength = (blockLengthMinutes / 1440) * 100;
        return 'calc(' + percentDayLength + '% - 1px)';
      };

      var setPosition = function() {

        const viewStartMoment = moment(scope.viewStartDateTime);
        const viewEndMoment = moment(scope.viewEndDateTime);

        const blockStartMoment = moment.max(unavailabilityStartTime, viewStartMoment);
        // If the leave block start datetime is the same as the end datetime,
        // we use the view end datetime to ensure the block is visible in the view.
        // This is necessary for cases where the leave block is All Day.
        const blockEndMoment = unavailabilityStartTime.isSame(unavailabilityEndTime) ? viewEndMoment : moment.min(unavailabilityEndTime, viewEndMoment);

        element.css({
          width: recordWidth(blockStartMoment, blockEndMoment),
          left: recordLeftPosition(blockStartMoment),
          top: '0px',
        });
      };

      setPosition();

      scope.pushedBack = false;

      // Handle clicks on the unavailability block.
      element.on('click', event => {

        // If there is a shift block behind this unavailability, we flip the stacking
        // context around so that it appears at the front and can then be clickable
        // by the user to edit it's details. Without this a 24hr unavailability block
        // would prevent the user from editing any shifts that fall within that block.
        const elementsBehind = document.elementsFromPoint(event.clientX, event.clientY);
        const shiftBehind = elementsBehind.find(el => el.classList.contains('day-shift'));

        if (shiftBehind) {
          // push the unavailability block back so the user can now click / drag on the shift
          // block which ends up being in front
          scope.pushedBack = true;
        } else {
          scope.pushedBack = false;
        }

      });

    }
  };
}]);
